<template>
  <div class="history">
    <div class="title">最近搜索记录</div>
    <div class="list">
      <ul>
        <li v-for="(item, index) in Histoty" :key="index">
          <span @click="searchHot(item)">{{ item }}</span>
          <div class="clear"></div>
        </li>
      </ul>
      <div @click="clear" class="clearAll">
        <i></i>
        清除所有搜索记录
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-silder-history",
  components: {},
  props: {
    cList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    // 从vuex中获取搜索记录
    Histoty() {
      return Array.from(new Set(this.$store.state.searchHistory)).filter(
        (item) => item
      );
    },
  },
  methods: {
    // searchRank(item) {
    //   // this.$emit("func", item);
    //   console.log(this);
    // },
    searchHot(item) {
      this.$emit("func", item);
    },
    clear() {
      this.$store.commit("claerHistoty");
    },
  },
  created() {
    // console.log(this.cList);
  },
  mounted() {},
};
</script>

<style lang='less' scoped>
.fl {
  float: left;
}
.clear {
  clear: both;
}
.history {
  width: 100%;
  max-height: 360px;
  margin-bottom: 40px;

  .title {
    width: 100%;
    height: 19px;
    font-size: 18px;
    font-weight: bold;
    // background-image: url("../../assets/img/hot_title.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-bottom: 20px;
    // border-bottom: 1px solid rgb(230, 230, 230);
  }
  .list {
    width: 100%;
    ul {
      margin: 0;
      padding: 0;
      li {
        height: 24px;
        width: 100%;
        margin-top: 10px;
        cursor: pointer;
        span {
          display: inline-block;
          width: 323px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          line-height: 17px;
        }
      }
    }
  }

  .clearAll {
    i {
      display: inline-block;
      width: 12px;
      height: 15px;
      background-image: url("../../assets/img/trash.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;
      top: 18%;
    }
    margin-top: 20px;
    color: #999999;
    cursor: pointer;
  }
}
</style>